import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import Intersect from 'vuetify/lib/directives/intersect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "persistent": "",
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t(_vm.modalTitle)) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_vm.selectedBridge && _vm.deviceObject ? [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "data-cy": "create_vd",
            "color": _vm.color,
            "disabled": !_vm.formValid || _vm.wmbusLimitExceeded || _vm.lwm2mLimitExceeded,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.save
          }
        }, [_c(VIcon, {
          attrs: {
            "left": ""
          }
        }, [_vm._v("fal fa-plus")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.create')) + "\n      ")], 1)] : _vm._e()];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [!_vm.isHeaderDataSelected ? _c(VRow, {
    staticClass: "vdevice-add-wizard pb-4 mb-0 pb-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "data-cy": "select_account",
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.accounts,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    model: {
      value: _vm.selectedAccount,
      callback: function ($$v) {
        _vm.selectedAccount = $$v;
      },
      expression: "selectedAccount"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.selectAccount')))])], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "4"
    }
  }, [_vm.useTemplate ? [_c(VAutocomplete, {
    attrs: {
      "data-cy": "select_Template",
      "disabled": _vm.accountTemplatesData.templates.length === 0,
      "loading": _vm.accountTemplatesData.isLoading,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.template'),
      "items": _vm.accountTemplatesData.templates,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "title",
      "item-value": "id",
      "hide-details": "",
      "disable-lookup": "",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.title) + " (ID " + _vm._s(data.item.id) + ")")]), _c(VListItemSubtitle)], 1)];
      }
    }, {
      key: "append-item",
      fn: function () {
        return [_c('div', {
          directives: [{
            def: Intersect,
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.endTemplatesIntersect,
            expression: "endTemplatesIntersect"
          }]
        })];
      },
      proxy: true
    }], null, false, 512522208),
    model: {
      value: _vm.selectedTemplate,
      callback: function ($$v) {
        _vm.selectedTemplate = $$v;
      },
      expression: "selectedTemplate"
    }
  }), _vm.accountTemplatesData.templates.length > 0 ? _c('p', {
    staticClass: "card-description mt-2 mb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.selectTemplate')) + "\n            ")]) : _vm._e(), _vm.selectedAccount && _vm.accountTemplatesData.templates.length === 0 ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noTemplateText')) + "\n              "), _c('br'), _c('router-link', {
    attrs: {
      "to": "/device-templates"
    }
  }, [_c('span', {
    class: `${_vm.color}--text`
  }, [_vm._v("\n                  » " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noTemplateLink')) + "\n                ")])])], 1) : _vm._e(), _c(VSwitch, {
    staticClass: "pt-2 pl-2 pb-0 mt-0",
    attrs: {
      "disabled": _vm.isHeaderDataSelected,
      "data-cy": "use_template_switch",
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.useTemplate'),
      "inset": "",
      "color": _vm.color
    },
    model: {
      value: _vm.useTemplate,
      callback: function ($$v) {
        _vm.useTemplate = $$v;
      },
      expression: "useTemplate"
    }
  })] : [_c(VAutocomplete, {
    attrs: {
      "data-cy": "select_ConnectorType",
      "disabled": _vm.deviceBridgesForAccount.length === 0,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.types'),
      "items": _vm.deviceBridgesForAccount,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "disable-lookup": "",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemAvatar, [_c(VAvatar, {
          attrs: {
            "size": "32"
          }
        }, [_vm.bridgeTypesIcons[data.item.type] ? _c('img', {
          attrs: {
            "src": _vm.bridgeTypesIcons[data.item.type],
            "alt": data.item.name,
            "title": data.item.name
          }
        }) : _vm._e()])], 1), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _c(VListItemSubtitle, [_vm._v("\n                    " + _vm._s(data.item.type.replace('bridge-', '')) + " (ID " + _vm._s(data.item.id) + ")\n                  ")])], 1)];
      }
    }], null, false, 411857261),
    model: {
      value: _vm.selectedBridge,
      callback: function ($$v) {
        _vm.selectedBridge = $$v;
      },
      expression: "selectedBridge"
    }
  }), !_vm.deviceBridgesLoading && _vm.deviceBridgesForAccount.length > 0 ? _c('p', {
    staticClass: "card-description mt-2 mb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.selectConnector')) + "\n            ")]) : _vm._e(), !_vm.deviceBridgesLoading && _vm.selectedAccount && _vm.deviceBridgesForAccount.length === 0 ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noConnectorText')) + "\n              "), _c('br'), _c('router-link', {
    attrs: {
      "to": "/connectors/list"
    }
  }, [_c('span', {
    class: `${_vm.color}--text`
  }, [_vm._v("\n                  » " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noConnectorLink')) + "\n                ")])])], 1) : _vm._e(), _c(VSwitch, {
    staticClass: "pt-2 pl-2 pb-0 mt-0",
    attrs: {
      "disabled": _vm.isHeaderDataSelected,
      "data-cy": "use_template_switch",
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.useTemplate'),
      "inset": "",
      "color": _vm.color
    },
    model: {
      value: _vm.useTemplate,
      callback: function ($$v) {
        _vm.useTemplate = $$v;
      },
      expression: "useTemplate"
    }
  })]], 2), _c(VCol, {
    attrs: {
      "cols": "2"
    }
  }, [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "data-cy": "change_connector_btn",
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionSwitchPromptButton'),
      "color": _vm.color,
      "rounded": "",
      "text": "",
      "disabled": ""
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-random")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionSwitchPromptButton')) + "\n          ")], 1)], 1)], 1) : _vm._e(), _vm.isHeaderDataSelected ? _c(VRow, {
    staticClass: "vdevice-add-wizard n20-mainrow pb-4 mb-0 pb-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "select_account",
      "value": _vm.accounts.find(a => a.id === _vm.selectedAccount).name,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": "",
      "readonly": "",
      "hide-details": ""
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "4"
    }
  }, [_vm.useTemplate ? [_c(VTextField, {
    attrs: {
      "data-cy": "select_template",
      "value": _vm.selectedTemplate.title,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": "",
      "readonly": "",
      "hide-details": ""
    }
  })] : [_c(VTextField, {
    attrs: {
      "data-cy": "select_connector",
      "value": _vm.selectedBridge.name,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": "",
      "readonly": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c(VListItemAvatar, [_c(VAvatar, {
          attrs: {
            "size": "32"
          }
        }, [_vm.bridgeTypesIcons[_vm.selectedBridge.type] ? _c('img', {
          attrs: {
            "src": _vm.bridgeTypesIcons[_vm.selectedBridge.type],
            "alt": _vm.selectedBridge.name,
            "title": _vm.selectedBridge.name
          }
        }) : _vm._e()])], 1)];
      },
      proxy: true
    }], null, false, 2018675018)
  })]], 2), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "2"
    }
  }, [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "data-cy": "switch_btn",
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionSwitchPromptButton'),
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.selectedAccount = null;
        _vm.searchExternalId = '';
        _vm.deviceExistsWarning = null;
        _vm.selectedTemplate = null;
        _vm.useTemplate = false;
        _vm.bridgeOfTemplateIsDeleted = false;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-random")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionSwitchPromptButton')) + "\n          ")], 1)], 1)], 1) : _vm._e(), (_vm.selectedBridge || _vm.selectedTemplate) && !_vm.deviceObject ? _c(VRow, {
    staticClass: "vdevice-add-wizard n20-mainrow pb-4 mb-0 pb-0",
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "center"
    }
  }, _vm._l(_vm.limits, function (limitExceeded, limitType, index) {
    return _c(VCol, {
      key: limitType,
      attrs: {
        "cols": "12"
      }
    }, [!limitExceeded ? [_vm.bridgeOfTemplateIsDeleted ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.bridgeOfTemplateIsDeleted')) + "\n              "), _c('br')]) : index === 0 ? _c('span', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.createText1')) + "\n            ")]) : _vm._e(), _vm.bridgeCanRead && index === 0 ? [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.importText1')) + "\n            ")] : _vm._e()] : [_c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t(`DigitalTwin.VirtualDevice.wizard.${limitType}LimitExceeded`)) + "\n              "), _c('br')])]], 2);
  }), 1) : _vm._e(), _c(VRow, [!_vm.deviceObject ? _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "data-cy": "create_btn",
      "title": _vm.$i18n_t('Common.create'),
      "color": _vm.color,
      "disabled": _vm.wmbusLimitExceeded || _vm.lwm2mLimitExceeded || _vm.bridgeOfTemplateIsDeleted || !_vm.selectedBridge,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.createNewDevice();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.create')) + "\n          ")], 1)], 1) : _vm._e(), _vm.bridgeCanRead ? _c(VCol, {
    staticClass: "mt-4 mb-0 pb-0",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.or')) + "\n        ")]) : _vm._e(), _vm.bridgeCanRead ? _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "7"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "search_ExternalId",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "disabled": _vm.wmbusLimitExceeded || _vm.lwm2mLimitExceeded,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": ""
    },
    on: {
      "keydown": function ($event) {
        _vm.deviceExistsWarning = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          staticStyle: {
            "margin-top": "-10px"
          },
          attrs: {
            "data-cy": "import_btn",
            "title": _vm.$i18n_t('accMgmt.user.import'),
            "color": _vm.color,
            "disabled": _vm.deviceExistsWarning || _vm.wmbusLimitExceeded || _vm.lwm2mLimitExceeded,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.findDeviceWithExternalId
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-cloud-download")]), _vm._v("\n                  " + _vm._s(_vm.$i18n_t('accMgmt.user.import')) + "\n              ")], 1)];
      },
      proxy: true
    }], null, false, 4184039075),
    model: {
      value: _vm.searchExternalId,
      callback: function ($$v) {
        _vm.searchExternalId = $$v;
      },
      expression: "searchExternalId"
    }
  })], 1) : _vm._e(), _vm.deviceExistsWarning ? [_c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "danger--text"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.existWarningText')) + "\n              (" + _vm._s(_vm.deviceExistsWarning.title) + " / " + _vm._s(_vm.deviceExistsWarning.id) + ")\n            ")])]), _c(VCol, [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.goToDevice'),
      "color": _vm.color,
      "to": `/virtual-devices/${_vm.deviceExistsWarning.id}`,
      "rounded": "",
      "text": ""
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-eye")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.goToDevice')) + "\n            ")], 1)], 1), _c('p', [_c('router-link', {
    attrs: {
      "to": `/virtual-devices/${_vm.deviceExistsWarning.id}`
    }
  }, [_vm._v("\n              >>> " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.goToDevice')) + " (" + _vm._s(_vm.deviceExistsWarning.title) + " /\n              " + _vm._s(_vm.deviceExistsWarning.id) + ")\n            ")])], 1)] : _vm._e()], 2), (_vm.selectedBridge || _vm.selectedTemplate) && _vm.deviceObject ? _c(VRow, {
    staticClass: "n20-mainrow pb-4 mb-0 pb-0",
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.deviceObject.properties.bridge.isDeviceImport ? [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.importText2')) + "\n          ")] : [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.createText2')) + "\n          ")], _c(VRow, {
    attrs: {
      "align": "start"
    }
  }, [_vm.hideFields.indexOf('title') < 0 ? _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "data-cy": "device_title",
      "disabled": _vm.createServerRequest,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
      "rules": [_vm.requiredRule]
    },
    model: {
      value: _vm.deviceObject.title,
      callback: function ($$v) {
        _vm.$set(_vm.deviceObject, "title", $$v);
      },
      expression: "deviceObject.title"
    }
  })], 1) : _vm._e(), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.useTemplate ? _c(VTextField, {
    attrs: {
      "data-cy": "device_parent_id",
      "value": `${_vm.templateParentObject.title} (ID:${_vm.templateParentObject.id})`,
      "disabled": "",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel')
    }
  }) : _c('core-dtwin-finder', {
    attrs: {
      "data-cy": "device_parent_id",
      "disabled": _vm.createServerRequest,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.selectedAccount,
      "objectFilter": _vm.parentSelectorFilter,
      "loadFullDtwinData": false,
      "sameTenant": "",
      "required": "",
      "hideDetails": ""
    },
    model: {
      value: _vm.deviceObject.parentId,
      callback: function ($$v) {
        _vm.$set(_vm.deviceObject, "parentId", $$v);
      },
      expression: "deviceObject.parentId"
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.markdownPreview ? _c(VCard, {
    staticClass: "elevation-0 v-card-text-area mdbox",
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.deviceObject.data.description || ''
    }
  })], 1)], 1) : _c(VCard, [_c(VTextarea, {
    attrs: {
      "data-cy": "device_description",
      "label": _vm.$i18n_t('Common.description'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.createServerRequest,
      "rows": "3",
      "hide-details": "auto",
      "clearable": ""
    },
    model: {
      value: _vm.deviceObject.data.description,
      callback: function ($$v) {
        _vm.$set(_vm.deviceObject.data, "description", $$v);
      },
      expression: "deviceObject.data.description"
    }
  })], 1), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "label": _vm.$i18n_t('Common.mdeditor'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.markdownPreview,
      callback: function ($$v) {
        _vm.markdownPreview = $$v;
      },
      expression: "markdownPreview"
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('core-tags', {
    attrs: {
      "tags": _vm.get(_vm.deviceObject, 'data.tags', []),
      "height": "120",
      "tagListType": "virtualDevice",
      "externalTags": _vm.get(_vm.selectedTemplate, 'deviceMeta.tags', [])
    },
    on: {
      "update:tags": _vm.setTags
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.deviceObject.data.virtualDevice ? _c(VCombobox, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.operationalStatus'),
      "items": _vm.operationalStatusItems,
      "return-object": false,
      "disabled": _vm.createServerRequest,
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": "",
      "data-cy": "select_operationalStatus"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function () {
        return [_vm.operationalStatus[parseInt(_vm.deviceObject.data.virtualDevice.operationalStatus)] ? [_vm._v("\n                    " + _vm._s(_vm.operationalStatus[parseInt(_vm.deviceObject.data.virtualDevice.operationalStatus)]) + "\n                  ")] : [_vm._v("\n                    " + _vm._s(_vm.deviceObject.data.virtualDevice.operationalStatus) + "\n                  ")]];
      },
      proxy: true
    }], null, false, 623948279),
    model: {
      value: _vm.deviceObject.data.virtualDevice.operationalStatus,
      callback: function ($$v) {
        _vm.$set(_vm.deviceObject.data.virtualDevice, "operationalStatus", $$v);
      },
      expression: "deviceObject.data.virtualDevice.operationalStatus"
    }
  }) : _vm._e()], 1), !_vm.useTemplate ? _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.useDriver ? _c(VAutocomplete, {
    attrs: {
      "data-cy": "device_devicedriver",
      "loading": _vm.deviceDriversData.isLoading,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.deviceDriver'),
      "items": _vm.deviceDriversData.deviceDrivers,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.createServerRequest,
      "search-input": _vm.deviceDriversData.driverSearch,
      "item-text": "title",
      "item-value": "id",
      "hide-details": ""
    },
    on: {
      "update:searchInput": function ($event) {
        return _vm.$set(_vm.deviceDriversData, "driverSearch", $event);
      },
      "update:search-input": function ($event) {
        return _vm.$set(_vm.deviceDriversData, "driverSearch", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                      " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                    ")])], 1)];
      }
    }, {
      key: "append-item",
      fn: function () {
        return [_c('div', {
          directives: [{
            def: Intersect,
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.endDriversIntersect,
            expression: "endDriversIntersect"
          }]
        })];
      },
      proxy: true
    }], null, false, 3711782),
    model: {
      value: _vm.deviceObject.data.virtualDevice.deviceDriverId,
      callback: function ($$v) {
        _vm.$set(_vm.deviceObject.data.virtualDevice, "deviceDriverId", $$v);
      },
      expression: "deviceObject.data.virtualDevice.deviceDriverId"
    }
  }) : _c(VAutocomplete, {
    attrs: {
      "data-cy": "device_devicetype",
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.title'),
      "items": _vm.deviceTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.createServerRequest,
      "item-text": "title",
      "item-value": "id",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                      " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                    ")])], 1)];
      }
    }], null, false, 2954919893),
    model: {
      value: _vm.deviceObject.data.virtualDevice.deviceTypeId,
      callback: function ($$v) {
        _vm.$set(_vm.deviceObject.data.virtualDevice, "deviceTypeId", $$v);
      },
      expression: "deviceObject.data.virtualDevice.deviceTypeId"
    }
  })], 1) : _c(VCol, [_c(VTextField, {
    attrs: {
      "data-cy": "device_driver",
      "value": _vm.selectedTemplate.devicedriver.title + ` (ID: ${_vm.selectedTemplate.devicedriver.id})`,
      "disabled": "",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.deviceDriverTemplate')
    }
  })], 1)], 1), _c(VRow, {
    attrs: {
      "align": "start"
    }
  }, [_c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceGroups'),
      "items": _vm.deviceGroups,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "disabled": _vm.createServerRequest,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "multiple": "",
      "small-chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function ({
        attrs,
        item
      }) {
        return [_c(VChip, _vm._b({
          attrs: {
            "small": "",
            "disabled": item.disabled
          }
        }, 'v-chip', attrs, false), [_vm._v("\n                    " + _vm._s(_vm.selectedTemplate ? item.value : item) + "\n                    "), _vm.selectedTemplate && _vm.selectedTemplate.deviceMeta.groups.includes(item.value) ? [_vm._v("\n                       \n                      "), _c(VIcon, {
          attrs: {
            "size": "small"
          }
        }, [_vm._v("fa-sitemap")])] : _vm._e()], 2)];
      }
    }], null, false, 3007401580),
    model: {
      value: _vm.deviceObject.properties.groups,
      callback: function ($$v) {
        _vm.$set(_vm.deviceObject.properties, "groups", $$v);
      },
      expression: "deviceObject.properties.groups"
    }
  })], 1), _c(VCol, {
    staticClass: "vdevice-add-wizard mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.createServerRequest,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.createNewGroup'),
      "hide-details": ""
    },
    on: {
      "keydown": _vm.restrictCharacters
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c(VBtn, {
          class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
          staticStyle: {
            "margin-top": "-10px"
          },
          attrs: {
            "disabled": _vm.newDeviceGroup.trim() === '' || _vm.createServerRequest,
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.addNew'),
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": _vm.addNewDeviceGroup
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-plus")])], 1)];
      },
      proxy: true
    }], null, false, 1428366284),
    model: {
      value: _vm.newDeviceGroup,
      callback: function ($$v) {
        _vm.newDeviceGroup = $$v;
      },
      expression: "newDeviceGroup"
    }
  })], 1)], 1), _vm.$slots['external'] ? [_c(VRow, [_vm._t("external")], 2)] : _vm._e(), _vm.useTemplate && _vm.hasCustomProperties ? [_c(VRow, [_c(VDivider, {
    staticClass: "mt-4"
  })], 1), _c(VRow, [_c(VCol, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.customProperties')))])])], 1), _vm._l(Object.keys(_vm.deviceObject.data.keyValue), function (customPropertyKey) {
    return _c(VRow, {
      key: `custom_prop_row_${customPropertyKey}`,
      staticClass: "my-1 py-1",
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": `custom_property_key_${customPropertyKey}`,
        "value": customPropertyKey,
        "disabled": "",
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.key'),
        "hide-details": ""
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "6"
      }
    }, [_c(VTextField, {
      class: _vm.templateCustomProperties[customPropertyKey].requiredValue ? 'required' : undefined,
      attrs: {
        "data-cy": `custom_property_value_${customPropertyKey}`,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.value'),
        "rules": _vm.templateCustomProperties[customPropertyKey].requiredValue ? [_vm.requiredRule] : undefined,
        "hide-details": ""
      },
      on: {
        "blur": () => {
          if (_vm.deviceObject.data.keyValue[customPropertyKey] === '') {
            _vm.deviceObject.data.keyValue[customPropertyKey] = undefined;
          }
        }
      },
      model: {
        value: _vm.deviceObject.data.keyValue[customPropertyKey],
        callback: function ($$v) {
          _vm.$set(_vm.deviceObject.data.keyValue, customPropertyKey, $$v);
        },
        expression: "deviceObject.data.keyValue[customPropertyKey]"
      }
    })], 1)], 1);
  })] : _vm._e(), _vm.useTemplate && _vm.hasReferenceIds ? [_c(VRow, [_c(VDivider, {
    staticClass: "mt-4"
  })], 1), _c(VRow, [_c(VCol, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.referenceIds')))])])], 1), _vm._l(_vm.deviceObject['dynamical-data-routing-target'] || [], function (referenceObj, index) {
    return _c(VRow, {
      key: `custom_prop_row_${index}`,
      staticClass: "my-1 py-1",
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": `reference_id_key_${index}`,
        "value": Object.keys(referenceObj)[0],
        "disabled": "",
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.key'),
        "hide-details": ""
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "6"
      }
    }, [_c(VTextField, {
      class: _vm.templateReferenceIds[Object.keys(referenceObj)[0]] && _vm.templateReferenceIds[Object.keys(referenceObj)[0]].requiredValue ? 'required' : undefined,
      attrs: {
        "data-cy": `reference_id_value_${index}`,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.value'),
        "rules": _vm.templateReferenceIds[Object.keys(referenceObj)[0]] && _vm.templateReferenceIds[Object.keys(referenceObj)[0]].requiredValue ? [_vm.requiredRule] : undefined,
        "hide-details": ""
      },
      on: {
        "blur": () => {
          if (referenceObj[Object.keys(referenceObj)[0]] === '') {
            referenceObj[Object.keys(referenceObj)[0]] = undefined;
          }
        }
      },
      model: {
        value: referenceObj[Object.keys(referenceObj)[0]],
        callback: function ($$v) {
          _vm.$set(referenceObj, Object.keys(referenceObj)[0], $$v);
        },
        expression: "referenceObj[Object.keys(referenceObj)[0]]"
      }
    })], 1)], 1);
  })] : _vm._e(), _c(VRow, [_c(VDivider, {
    staticClass: "mt-4"
  })], 1), _c(VRow, [_c(VCol, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.connectorData')))])])], 1), _vm.useTemplate ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "selected_template_connector",
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.connector'),
      "value": _vm.selectedBridge.name,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": "",
      "readonly": "",
      "hide-details": ""
    }
  })], 1)], 1), _c(VRow, _vm._l(_vm.templateBridgeCreateFields, function (configKey) {
    return _c(VCol, {
      key: `bridge_config_item_${configKey}`,
      staticClass: "my-1 py-1",
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('core-tenant-bridge-config-field', {
      attrs: {
        "fieldConfig": _vm.bridgeCreateParameters[configKey],
        "bridgeConfig": _vm.selectedBridge.bridge.config,
        "bridgeConfigId": _vm.selectedBridge.id,
        "bridgeType": _vm.selectedBridge.type,
        "configKey": configKey,
        "bridgeManifest": _vm.bridgeConfig(_vm.selectedBridge).manifest,
        "disabled": _vm.createServerRequest || _vm.deviceObject.properties.bridge.isDeviceImport,
        "bridgeHasValidParametersStrict": false,
        "dependsOnFieldValue": _vm.getDependsOnFieldValue(_vm.bridgeCreateParameters, configKey, _vm.deviceObject.properties.bridge.deviceData),
        "bridgeHasValidParameters": "",
        "brigdeHasError":
        // component must have brigdeHasError to add required rules for the field
        // https://digimondo.atlassian.net/browse/RD-6070
        true
      },
      on: {
        "changedBridgeParams": _vm.deviceConfigChanged
      },
      model: {
        value: _vm.deviceObject.properties.bridge.deviceData[configKey],
        callback: function ($$v) {
          _vm.$set(_vm.deviceObject.properties.bridge.deviceData, configKey, $$v);
        },
        expression: "deviceObject.properties.bridge.deviceData[configKey]"
      }
    })], 1);
  }), 1)] : [_c(VRow, _vm._l(_vm.bridgeCreateFields, function (configKey) {
    return _c(VCol, {
      key: `bridge_config_item_${configKey}`,
      staticClass: "my-1 py-1",
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('core-tenant-bridge-config-field', {
      attrs: {
        "fieldConfig": _vm.bridgeCreateParameters[configKey],
        "bridgeConfig": _vm.selectedBridge.bridge.config,
        "bridgeConfigId": _vm.selectedBridge.id,
        "bridgeType": _vm.selectedBridge.type,
        "configKey": configKey,
        "bridgeManifest": _vm.bridgeConfig(_vm.selectedBridge).manifest,
        "disabled": _vm.createServerRequest || _vm.deviceObject.properties.bridge.isDeviceImport,
        "bridgeHasValidParametersStrict": false,
        "dependsOnFieldValue": _vm.getDependsOnFieldValue(_vm.bridgeCreateParameters, configKey, _vm.deviceObject.properties.bridge.deviceData),
        "bridgeHasValidParameters": "",
        "brigdeHasError":
        // component must have brigdeHasError to add required rules for the field
        // https://digimondo.atlassian.net/browse/RD-6070
        true
      },
      on: {
        "changedBridgeParams": _vm.deviceConfigChanged
      },
      model: {
        value: _vm.deviceObject.properties.bridge.deviceData[configKey],
        callback: function ($$v) {
          _vm.$set(_vm.deviceObject.properties.bridge.deviceData, configKey, $$v);
        },
        expression: "deviceObject.properties.bridge.deviceData[configKey]"
      }
    })], 1);
  }), 1)]], 2)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };